// extracted by mini-css-extract-plugin
export default {"buttonContainer":"PrimaryButton-module--buttonContainer--i0-vw","button":"PrimaryButton-module--button--ChU+h","buttonPrimaryHome":"PrimaryButton-module--buttonPrimaryHome--NfJYS"};